module.exports = __webpack_public_path__ + "static/Happy-0dbf07040f77d779d242c20499ae558f.jpg";